module.exports = __webpack_public_path__ + "img/82d90f6.png";